module.exports = __webpack_public_path__ + "img/glassquality_4.85cb49c8.png";